import { ConfirmationDialog } from "@trcsolutions/springboard-ui";
import useLogout from "mutationHooks/authMutationHooks/useLogout";
import useGetIdleTimerConfig from "queryHooks/configurationHooks/useGetIdleTimerConfig";
import { useState, useEffect } from "react";
import { useIdleTimer } from "react-idle-timer";

const defaultTimeout = 9_00_000;
const promptBeforeIdle = 60_000;

const IdleTimer = () => {
    const [remaining, setRemaining] = useState<number>(defaultTimeout);
    const [open, setOpen] = useState<boolean>(false);
    const logout = useLogout();
    const { data } = useGetIdleTimerConfig()
    const [timeout, setTimeout] = useState(defaultTimeout)

    useEffect(() => {
        if (!(data && data.idletimeout)) return
        let timeout = data.idletimeout * 60 * 1000
        setTimeout(timeout)
        setRemaining(timeout)
    }, [data])

    const { getRemainingTime, activate } = useIdleTimer({
        onIdle,
        onActive,
        onPrompt,
        timeout,
        promptBeforeIdle,
        throttle: 500,
    });

    useEffect(() => {
        const interval = setInterval(() => {
            setRemaining(Math.ceil(getRemainingTime() / 1000));
        }, 500);

        return () => {
            clearInterval(interval);
        };
    });

    function onIdle() {
        setOpen(false)
        logout.mutate()
    }

    function onActive() {
        setOpen(false);
    }

    function onPrompt() {
        setOpen(true);
    }

    function handleStaySignedIn() {
        activate();
    }

    function handleSignOut() {
        logout.mutate()
    }

    const content = (
        <>
            You've been inactive for a while. For security reasons, we'll automatically sign you out in approximately <span className="text-danger">{remaining} sec</span>. Choose <span className="fw-bold text-primary">Stay signed in</span> to continue or <span className="fw-bold text-danger">Sign Out</span> if you're done.
        </>
    )

    return (
        <ConfirmationDialog
            show={open}
            handleClose={() => setOpen(false)}
            handleSubmit={handleStaySignedIn}
            handleCancel={handleSignOut}
            content={content}
            title="Your session is about to end."
            submitBtnText="Stay signed in"
            cancelBtnText="Sign Out"
            showCloseBtn={false}
        />
    );
};

export default IdleTimer;
